<template>
	<HeroComponent>

		<template v-slot:hero-image>
			<div class="background-banner-profile-page w-100 h-100 d-flex flex-row justify-center" style="position: relative;">
				<profile-banner-item1 class="profile-banner__item1"></profile-banner-item1>
				<v-img :src="AppConfigs.staticImages.HANDWITHGOLDENCOINSLYINGPALM" class="profile-banner__item2">
				</v-img>
			</div>
		</template>


		<template v-slot:hero-title>
			My Profile
		</template>


		<template v-slot:hero-subtitle>
			Track overall progress and earnings.
		</template>

	</HeroComponent>
</template>


<script setup>

import { AppConfigs } from "@/app.configs";
import ProfileBannerItem1 from '@/icons/ProfileBannerItem1.vue';
import HeroComponent from '@/components/Common/Hero-Component.vue';

</script>



<style scoped lang="scss">
@use '@/assets/scss/components/profile.scss' as profile;
</style>
